<p-button
  [rounded]="true"
  icon="fas fa-info"
  severity="info"
  styleClass="p-button-xs"
  (click)="op.toggle($event)"></p-button>
<p-overlayPanel #op [showCloseIcon]="true" [styleClass]="'w-6'">
  <div class="overflow-y-scroll h-30rem">
    <app-indicator-detail
      *ngIf="indicator"
      [indicator]="indicator"
      [displayIndicatorData]="true" />
  </div>
</p-overlayPanel>
